import axiosInstance from "./axiosInstance";

// base url to gateway which will do all the proxies
const gatewayEndPoint = process.env.REACT_APP_API_STAGING;

class RequestError extends Error {
    constructor(message, status) {
        super(message);
        this.name = `RequestError`;
        this.status = status;
    }
}

const requestOptions = {
    method : "GET",
    withCredentials : false,
    headers : {
        "Content-Type" : "application/json"
    }
}

const getRequest = async(url, options = requestOptions) => {
    try {
        let res = await axiosInstance(process.env.REACT_APP_API_STAGING + url, options);
        return res.data;
    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        const data = error.response?.data ?? error.message ?? "Network error";
        throw new RequestError(data, error.response?.status)
    }
}

// const getRequest = async(url) => {
//     let requestOptions = {
//         method : "GET",
//         withCredentials : false,
//         headers : {
//             "Content-Type" : "application/json"
//         }
//     }

//     try {
        
//         let res = await axiosInstance(process.env.REACT_APP_API_STAGING + url, requestOptions);

//         if(res.status === 400 || res.status === 500){
//             console.log(`Error is: ${res.data}`)
//         } else {
//             // console.log(res.data)
//             return res.data;
//         }

//     } catch (error) {
//         if(error){
//             return error.response.data
//         }
//     }
// }

const getRequestWithParams = async(url,data) => {
    let requestOptions = {
        method : "GET",
        withCredentials : false,
        headers : {
            "Content-Type" : "application/json"
        },
        params : data
    }

    try {
        
        let res = await axiosInstance(process.env.REACT_APP_API_STAGING + url, requestOptions);

        if(res.status === 400 || res.status === 500){
        } else {
            // console.log(res.data)
            return res.data;
        }

    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        if(!error.response){
            return { err : error.message || "Network error" }
        }
        if(error.response.status === 500){
            return {
                err : error.response.statusText
            }
        }
        return error.response.data
    }
}

// A file download uses responseType "blob", so an error response body arrives as a
// Blob (the server's JSON { err }), not a parsed object. Decode it so callers get a
// plain { err } string instead of a Blob — a leaked Blob defeats the caller's
// `res?.err` check and then crashes on `res.headers` (undefined).
const extractBlobError = async (data, statusText) => {
    const fallback = statusText || "Could not download file";
    try {
        if (data instanceof Blob) {
            const text = await data.text();
            try { return JSON.parse(text)?.err || fallback; }
            catch { return text || fallback; }
        }
        if (data && typeof data === "object") return data.err || fallback;
        return fallback;
    } catch {
        return fallback;
    }
};

const accessFileRequest = async(url, headers, params) => {
    let requestOptions = {
        method : "GET",
        withCredentials : false,
        headers,
        params,
        responseType : "blob"
    }

    try {

        let res = await axiosInstance(gatewayEndPoint + url, requestOptions);

        if(res.status >= 400){
            return { err : await extractBlobError(res.data, res.statusText) };
        }
        return res;

    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        if(!error.response){
            return { err : error.message || "Network error" }
        }
        return { err : await extractBlobError(error.response.data, error.response.statusText) };
    }
}


const uploadFileRequest = async(url, headers, formData) => {
    let requestOptions = {
        method : "POST",
        withCredentials : false,
        headers,
        data : formData
    }

    try {
        let res = await axiosInstance(gatewayEndPoint + url, requestOptions);
        if(res.status === 400 || res.status === 500){
        } else {
            // console.log(res.data)
            return res?.data;
        }

    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        if(!error.response){
            return { err : error.message || "Network error" }
        }
        if(error.response.status === 500){
            return {
                err : error.response.statusText
            }
        }
        return error.response.data
    }
}


const fetchRequests = async(url, method, headers, params, data) => {
    let options = {
        method : method,
        withCredentials : false,
        headers,
        params,
        data
    }

    try {

        let res = await axiosInstance(gatewayEndPoint + url, options);
        if(res.status === 400 || res.status === 500){
        } else {
            return res.data;
        }
        
    } catch (error) {
        if(error){
            if(error.response.status === 500){
                return {
                    err : error.response.statusText
                }
            }

            return error.response.data
        }
    }
}

const adminPortalRequest = async(url, method, headers, params, data) => {
    let options = {
        method : method,
        withCredentials : false,
        headers,
        params,
        data
    }

    try {

        let res = await axiosInstance(gatewayEndPoint + url, options);
        if(res.status === 400 || res.status === 500){
        } else {
            return res.data;
        }
        
    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        if(!error.response){
            return { err : error.message || "Network error" }
        }
        if(error.response.status === 500){
            return {
                err : error.response.statusText
            }
        }
        return error.response.data
    }
}

const reportsRequest = async(url, method, headers, params, data) => {
    let options = {
        method : method,
        withCredentials : false,
        headers,
        params,
        data,
        responseType : "blob"
    }

    try {

        let res = await axiosInstance(process.env.REACT_APP_STAGING_REPORT + url, options);
        if(res.status === 400 || res.status === 500){
        } else {
            return res;
        }
        
    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        if(!error.response){
            return { err : error.message || "Network error" }
        }
        if(error.response.status === 500){
            return {
                err : error.response.statusText
            }
        }
        return error.response.data
    }
}

export {
    getRequest,
    getRequestWithParams,
    accessFileRequest,
    uploadFileRequest,
    fetchRequests,
    adminPortalRequest,
    reportsRequest
}